import React, { useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
  disableScrollLock: true, // for sticky position of menu items
};

// const names = [
//     'Air Conditioner',
//     'Child Seat',
//     'Music',
//     'Safty Gear',
//     'Manual',
//     'Automatic',
// ];
const style = getComputedStyle(document?.body);
const accent = style?.getPropertyValue("--accent");

function getStyles(name, feature, theme) {
  // console.log(name,feature,theme,1450,)
  return {
    fontWeight:
    feature && name && feature?.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: feature && name && feature.indexOf(name) === -1 ? "" : accent,
  };
}

// export default function MultipleSelectChip({
 function MultipleSelectChip({
  feature,
  setFeature,
  labelName,
  placeholder,
  value,
  options,
  helperText,
  error,
  name,
  id,
  requiredStar,
  setPassenger,
  setErrMsg,
  isBlock
}) {
  const theme = useTheme();
  // const [feature, setfeature] = React.useState([]);

  const [menuOpen, setMenuOpen] = React.useState(false);

  // React.useEffect(() => {
  //     const handleScroll = () => {
  //         if (menuOpen) {
  //             setMenuOpen(false);
  //         }
  //     };

  //     window.addEventListener('scroll', handleScroll);

  //     return () => {
  //         window.removeEventListener('scroll', handleScroll);
  //     };
  // }, [menuOpen]);

  // useEffect(() => {
  //     const handleScroll = () => {
  //         if (menuOpen) {
  //             setMenuOpen(false);
  //         }
  //     };
  //     window.addEventListener('scroll', handleScroll);
  //     return () => {
  //         window.removeEventListener('scroll', handleScroll);
  //     };
  // }, [menuOpen]);
// console.log(value,feature,name,888888)
  useEffect(() => {
    // Update state if the incoming value prop changes
    if (value) {
      setFeature(value);
    }
  }, [value, setFeature]);

  const handleOpen = () => {
    setMenuOpen(true);
  };

  const handleClose = () => {
    setMenuOpen(false);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    if (setErrMsg) {
      setErrMsg((prev) => ({ ...prev, [event.target.name]: "" }));
    }
    setFeature(typeof value === "string" ? value.split(",") : value);
    if (setPassenger) {
      // code added to clear seat var in search
      setPassenger([]);
    }
  };
  const names = [
    "Oliver Hansen",
    "Van Henry",
    "April Tucker",
    "Ralph Hubbard",
    "Omar Alexander",
    "Carlos Abbott",
    "Miriam Wagner",
    "Bradley Wilkerson",
    "Virginia Andrews",
    "Kelly Snyder",
  ];
  return (
    <div>
      <label className="input-label my-2">
        {labelName}
        {requiredStar ? null : <span style={{ color: "red" }}>*</span>}
      </label>
      <FormControl error={error} fullWidth className="multi-tag">
        <InputLabel size="small" id={name}>
          {placeholder}
        </InputLabel>
        {/* <Select
          labelId={name}
          id={id}
          size="small"
          multiple
          value={feature}
          onChange={handleChange}
          input={
            <OutlinedInput id="select-multiple-chip" label="Select Features" />
          }
          renderValue={(selected) => (
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 0.5,
                maxHeight: 150,
                overflowY: "auto",
              }}
            >
              {selected.map((value) => {
                const selectedOption = options.find(
                  (option) => option._id === value
                );

                return (
                  <Chip
                    key={value}
                    label={selectedOption ? selectedOption.name : ""}
                  />
                );
              })}
            </Box>
          )}
          MenuProps={{
            open: menuOpen,
            onClose: handleClose,
            disableScrollLock: true,
          }}
          onOpen={handleOpen}
        >
          {options?.map((option) => (
            <MenuItem
              className="text-capitalize"
              key={option?._id}
              value={option?._id}
              style={getStyles(option?._id, feature, theme)}
            >
              {option?.name}
            </MenuItem>
          ))}
        </Select> */}
        <Select
          MenuProps={MenuProps}
          labelId={name}
          id={id}
          size="small"
          name={name}
          multiple
          value={feature}
          onChange={handleChange}
          input={
            <OutlinedInput id="select-multiple-chip" label="Select Features" />
          }
          onOpen={handleOpen}
          disabled={isBlock?true:false}
        >
          {options?.map((option) => (
            <MenuItem
              className="text-capitalize"
              key={option?._id}
              value={option?._id}
              style={!isBlock?getStyles(option?._id, feature, theme):null}
            >
              {option?.name}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </div>
  );
}
export default React.memo(MultipleSelectChip);
